let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("352DW")).then(() => parcelRequire('drGkM'));